import { useSaleStore } from '@/stores/sale.store';

interface TReturn {
  saleId: string | null;
  setSaleId: (value: string) => void;
  resetSaleId: () => void;
}

export function useSaleId(): TReturn {
  return useSaleStore();
}
